import { useHttp } from '@/api'
import { httpApi } from '@/api/api'

/**
 * 発送予定一覧：検索条件リストの初期化(状態)
 */
export function initPrepTransSearchList(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.InitPrepTransSearchList, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 検索発送予定一覧情報
export function searchPrepTransBasic(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchPrepTransBasic, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 発送予定一覧：発送予定No.によると、発送予定基本情報と明細情報の削除
export function delPrepTransBasicByNo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.DelPrepTransBasicByNo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

//====================================発送予定詳細画面==============================
// 発送予定明細：基本情報のリスト取得（運送状態、担当者、輸送方式、製品異常区分、仕入先リスト）
export function getInitList(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetInitList, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 発送予定明細：発送予定No.によると、発送予定基本情報と明細情報の検索
export function searchPrepTransDetailByNo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchPrepTransDetailByNo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 発送予定明細：明細情報の削除
export function delPrepTransByDetailNo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.DelPrepTransByDetailNo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 発送予定製品選択画面：製品情報の検索
export function searchProdSelectInfo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.SearchProdSelectInfo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 発送予定製品選択画面：製品情報の検索⇒発送予定明細
export function getProdSelectData(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetProdSelectData, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 発送予定明細：発送予定基本情報と明細情報の新規追加
export function addPrepTransDetail(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.AddPrepTransDetail, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 発送予定明細：発送予定No.によると、発送予定基本情報と明細情報の更新
export function updPrepTransDetail(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.UpdPrepTransDetail, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}
// 発送予定明細：運送データの作成
export function transInfoCreate(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.TransInfoCreate, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}


